import { ButtonHTMLAttributes, FC } from 'react';

import { FiPlus } from 'react-icons/fi';

import { Container, ButtonText } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

const ButtonAdd: FC<ButtonProps> = ({ children, ...rest }) => (
  <Container type="button" {...rest}>
    <FiPlus size={30} color="#000" />

    <ButtonText>{children}</ButtonText>
  </Container>
);

export default ButtonAdd;
